import styled from "styled-components";
export const propsToThemeCSS = (props) => Object.keys(props)
    .map((p) => props.theme.css[p])
    .filter((c) => c);
export const Div = styled.div(propsToThemeCSS);
export const HTMLButton = styled.button(propsToThemeCSS);
export const Span = styled.span(propsToThemeCSS);
export const HtmlP = styled.p(propsToThemeCSS);
export const HtmlH1 = styled.h1(propsToThemeCSS);
export const HtmlH2 = styled.h2(propsToThemeCSS);
export const HtmlH3 = styled.h3(propsToThemeCSS);
export const HtmlH4 = styled.h4(propsToThemeCSS);
export const HtmlLabel = styled.label(propsToThemeCSS);
//# sourceMappingURL=index.js.map